import React from 'react';
import debounce from 'lodash/debounce';
import { useSensor } from './use-sensor';

const forceResize = debounce(() => {
  window?.dispatchEvent(new Event('resize'));
}, 100);

/**
 * Component that triggers **resize** event when the size of its children is changed.
 *
 * It can be used to automatically adjust the size of react-textarea-autosize component
 * when wrapper component size is changed.
 */
export const PropagateResize: React.FC = ({ children }) => {

  const ref = useSensor<HTMLDivElement>(forceResize);

  return <div className={'resize-sensor'} ref={ref}>
    {children}
  </div>;
};
